export function roleLabel(staffRole) {
  if (staffRole === 'OWNER') return 'Sahip';
  if (staffRole === 'ADMIN') return 'Yönetici';
  return 'Personel';
}

export function workTypeLabel(w) {
  switch (w) {
    case 'FULL_TIME':
      return 'Tam Zamanlı (Maaş)';

    case 'FULL_TIME_BONUS':
      return 'Maaş + Prim';

    case 'HOURLY':
      return 'Saatlik';

    case 'HOURLY_BONUS':
      return 'Saatlik + Prim';

    case 'PERCENT':
      return 'Yüzde';

    default:
      return '—';
  }
}

export function statusChip(active) {
  return active
    ? { label: 'Aktif', color: 'success', icon: 'check_circle' }
    : { label: 'Pasif', color: 'error', icon: 'cancel' };
}

export function moneyTry(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      maximumFractionDigits: 0,
    }).format(Number(n));
  } catch {
    return `${n} ₺`;
  }
}
